exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shepherd-element{border:2px solid #000}.shepherd-element[data-popper-placement=bottom] .shepherd-arrow:before{border-top:2px solid #000;border-left:2px solid #000}.shepherd-element[data-popper-placement=top] .shepherd-arrow:before{border-bottom:2px solid #000;border-right:2px solid #000}.shepherd-header{border-bottom:2px solid #000!important}", ""]);

// exports
